import ClipboardItem from './ClipboardItem';

class ImageItem extends ClipboardItem {
  constructor(rawItem, status = ClipboardItem.STATUS_PERSISTED) {
    const { id, content_type, content_url, created_at } = rawItem;
    super(id, status, content_type, content_url, created_at);
    this.raw = rawItem; // Store raw item for reference
    this._imageUrl = null;
    this._thumbnailUrl = null;
  }

  // Get image URL (with presigned URL if needed)
  getImageUrl() {
    if (this._imageUrl) return this._imageUrl;
    
    // If the API provides a direct URL, use it
    if (this.contentUrl) {
      this._imageUrl = this.contentUrl;
      return this._imageUrl;
    }

    // Otherwise construct the URL
    this._imageUrl = `/api/clipboard/${this.clipboardId}/items/${this.id}/content`;
    return this._imageUrl;
  }

  // Get thumbnail URL if available
  getThumbnailUrl() {
    if (this._thumbnailUrl) return this._thumbnailUrl;
    
    if (this.raw.thumbnail_url) {
      this._thumbnailUrl = this.raw.thumbnail_url;
      return this._thumbnailUrl;
    }

    // Fallback to main image URL
    return this.getImageUrl();
  }

  // Get file size if available
  getFileSize() {
    return this.raw.file_size || null;
  }

  // Get formatted file size
  getFormattedFileSize() {
    const size = this.getFileSize();
    if (!size) return null;
    
    const units = ['B', 'KB', 'MB', 'GB'];
    let unitIndex = 0;
    let fileSize = size;
    
    while (fileSize >= 1024 && unitIndex < units.length - 1) {
      fileSize /= 1024;
      unitIndex++;
    }
    
    return `${fileSize.toFixed(1)} ${units[unitIndex]}`;
  }

  getType() {
    return 'image';
  }
}

export default ImageItem;
